import { Dispatch } from 'redux';
import {
  searchDocumentImagesService,
  fetchStatesService,
  fetchDriversService,
  fetchXDetailsService,
  fetchLicenseFlag,
} from './Preacris.services';
import {
  SetResultLoadingType,
  PREACRIS_SET_LOADING,
  RESET_RESULTS,
  ResetResultsType,
  GetStatesSuccessType,
  GET_PREACRIS_STATES_SUCCESS,
  RESET_DRIVERS_DATA,
  ResetDriversDataType,
  GET_PREACRIS_DRIVERS_SUCCESS,
  GetDriversSuccessType,
  ResetXDetailsDataType,
  RESET_XDETAILS_DATA,
  GetXDetailsSuccessType,
  GET_PREACRIS_XDETAILS_SUCCESS,
} from './Preacris.types';
import {
  httpError,
  json,
  showWarnNotification,
  showSuccessNotification,
} from 'common';
import { AppState } from 'store';
import { USStates, DriversResult, XDetailsResult } from './model';

const getStatesSuccess = (usStates: USStates): GetStatesSuccessType => ({
  type: GET_PREACRIS_STATES_SUCCESS,
  usStates,
});

let alreadyCalledGetStates = false;

export const getStates = (bearerToken: string) => (dispatch: Dispatch) => {
  dispatch(setResultLoading(true));
  fetchStatesService(bearerToken)
    .then(httpError(dispatch))
    .then(json)
    .then((response) => {
      if (response.errorMessage) throw Error(response.errorMessage);
      dispatch(getStatesSuccess(response));
      dispatch(setResultLoading(false));
    })
    .catch((error) => {
      dispatch(setResultLoading(false));
      showWarnNotification(`States`, error.message);
    })
    .finally(() => (alreadyCalledGetStates = true));
};

export const getLicenseFlag =
  (username: string, bearerToken: string) => (dispatch: Dispatch) => {
    fetchLicenseFlag(username, bearerToken)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
      })
      .catch((error) => {
        showWarnNotification(`License Agreement`, error.message);
      });
  };

export const getDrivers =
  (
    statehob: string,
    countyhob: string,
    cmtdocId: string,
    driversData: DriversResult,
    token: string,
  ) =>
  (dispatch: Dispatch) => {
    dispatch(setResultLoading(true));
    fetchDriversService(statehob, countyhob, cmtdocId, token)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        const result = response.drivers.length ? response : { ...driversData };

        dispatch(getDriversSuccess(result));

        if (alreadyCalledGetStates) {
          dispatch(setResultLoading(false));
        }
      })
      .catch((error) => {
        dispatch(setResultLoading(false));
        showWarnNotification('Service Type Drivers', error.message);
      });
  };

export const getXDetails =
  (
    statehob: string,
    countyhob: string,
    cmtdocId: string,
    xdetailsData: XDetailsResult,
    token: string,
  ) =>
  (dispatch: Dispatch) => {
    dispatch(setResultLoading(true));
    fetchXDetailsService(statehob, countyhob, cmtdocId, token)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        const result = response.drivers.length ? response : { ...xdetailsData };
        dispatch(getXDetailsSuccess(result));

        if (alreadyCalledGetStates) {
          dispatch(setResultLoading(false));
        }
      })
      .catch((error) => {
        dispatch(setResultLoading(false));
        showWarnNotification('Service Type Drivers', error.message);
      });
  };

const setResultLoading = (loading: boolean): SetResultLoadingType => ({
  type: PREACRIS_SET_LOADING,
  loading,
});

export const resetResults = (): ResetResultsType => ({
  type: RESET_RESULTS,
});

export const searchDocuments =
  (docId: string, formValues: any, driversData: DriversResult, token: string) =>
  (dispatch: Dispatch) => {
    const { driversSearch, searchName } = formValues;

    const body = {
      docId,
      docDescs: drivervalues(driversSearch, driversData),
      searchName,
    };
    //const body = { ...formValues, exportFormat };
    dispatch(setResultLoading(true));
    dispatch(resetResults());
    searchDocumentImagesService(body, token)
      .then(httpError(dispatch))
      .then(json)
      .then((response: any) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        showSuccessNotification(
          'Documents Images Online',
          'Your documents will be ready soon. Please check "Recent Reports".',
        );
        dispatch(setResultLoading(false));
      })
      .catch((error: any) => {
        dispatch(setResultLoading(false));
        showWarnNotification('Documents Images Online', error.message);
      });
  };

const getDriversSuccess = (
  driversData: DriversResult,
): GetDriversSuccessType => ({
  type: GET_PREACRIS_DRIVERS_SUCCESS,
  driversData,
});

const drivervalues = (driversSearch: any, driversData: DriversResult) => {
  let num = '';
  for (let _i = 0; _i < driversData.drivers.length; _i++) {
    num = num + driversSearch[_i] + '.';
  }
  return num;
};

export const resetDriversData = (): ResetDriversDataType => ({
  type: RESET_DRIVERS_DATA,
});

export const resetXDetailsData = (): ResetXDetailsDataType => ({
  type: RESET_XDETAILS_DATA,
});

const getXDetailsSuccess = (
  xdetailsData: XDetailsResult,
): GetXDetailsSuccessType => ({
  type: GET_PREACRIS_XDETAILS_SUCCESS,
  xdetailsData,
});
